import { useState, useEffect } from 'react'
import { successfulLogins as storeSuccessfulLogins } from '@store'

/**
 * For only admins, only in develop, successful logins are cached
 * locally, encrypted, in the browser for easier sign in when developing
 * 
 * @returns {object} data
 * @returns {object[]} data.successfulLogins Map of { email: encrypted-payload } of saved logins
 */
const useAdminAuth = () => {
    
    // Ephemeral list of previously saved successful logins
    const [successfulLogins, setSuccessfulLogins] = useState(null)
    
    useEffect(() => {
        
        // Only set this state if in develop mode
        if (process.env.NODE_ENV === 'development')
            setSuccessfulLogins(storeSuccessfulLogins.getValue())
        
    }, [])
    
    return {
        successfulLogins: (
            process.env.NODE_ENV === 'development'
                ? successfulLogins
                : null
        ),
    }
    
}

export default useAdminAuth
